import { SearchFacet } from 'modules/search/types/SearchFacet';
import { SearchType } from 'modules/search/types/SearchType';

import { searchFacetsEvent } from './searchFacetsEvent';
import { searchFacetsInternship } from './searchFacetsInternship';
import { searchFacetsJob } from './searchFacetsJob';
import { searchFacetsOrg } from './searchFacetsOrg';
import { searchFacetsVolop } from './searchFacetsVolop';

/**
 * Do not import this on public pages, as it causes all facets to be included in the bundle
 */
export const searchFacetsByType = {
  JOB: searchFacetsJob,
  INTERNSHIP: searchFacetsInternship,
  VOLOP: searchFacetsVolop,
  EVENT: searchFacetsEvent,
  ORG: searchFacetsOrg,
} satisfies Record<SearchType, SearchFacet[]>;
